'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$22() {
  this.axE = null;
  this.axF = false;
}
export { $c_Lpresto_AgentView$$anon$22 as $c_Lpresto_AgentView$$anon$22 };
$p = $c_Lpresto_AgentView$$anon$22.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$22;
/** @constructor */
function $h_Lpresto_AgentView$$anon$22() {
}
export { $h_Lpresto_AgentView$$anon$22 as $h_Lpresto_AgentView$$anon$22 };
$h_Lpresto_AgentView$$anon$22.prototype = $p;
$p.P = (function() {
  if ((!this.axF)) {
    this.axE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.axF = true;
  }
  return this.axE;
});
var $d_Lpresto_AgentView$$anon$22 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$22, "presto.AgentView$$anon$22", ({
  DM: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$22 as $d_Lpresto_AgentView$$anon$22 };
//# sourceMappingURL=presto.-Agent-View$$anon$22.js.map
